<template>
  <div class="update-log">
    <div class="update-log-inner" :style="{height: tableHeight + 'px'}">
      <div>{{updateLogTitle}}</div>
      <div class="firstChild">{{updateLogTime}}</div>
      <!-- <div class="update-log-line"></div> -->
      <!-- <ul>
        <li v-for="item in updateLogData" :key="item.id">
          <span class="update-log-title">{{ item.title }}
          </span>
          <span class="update-log-time">{{ item.create_time | createTimeFilter }}</span>
        </li>
      </ul> -->
      <div class="updateLogContent">
        {{updateLogContent}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "UpdateLog",
  data() {
    return {
      updateLogData: [
        {
          id: 1,
          title: "日志1",
          create_time: "2020-04-10 02:16",
          update_time: "2020-04-10 02:16",
        },
      ],
      updateLogTitle: '',
      updateLogTime: '',
      updateLogContent: '',
      tableHeight: window.innerHeight - 492,
      clientHeight: window.innerHeight - 492
    };
  },
  watch: {
    clientHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.clientHeight = val
        this.tableHeight = this.clientHeight - 492
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  },
  created: function () {
    // this.getUpateLog();
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        that.clientHeight = window.screenHeight
        that.tableHeight = that.clientHeight - 492
      })()
    }
    this.getData()
  },
  methods: {
    getData() {
      let params = {
        id: this.$route.query.id,
      };
      this.http.get('log/detail', params).then((res) => {
        // if (res.data.code == 200) {
        this.updateLogTitle = res.data[0].title
        this.updateLogTime = res.data[0].create_time.split(' ')[0]
        this.updateLogContent = res.data[0].content
        // }
      }).catch((err) => {
        console.log(err);
      });
    },
    getUpateLog: function () {
      var that = this;
      that.$axios
        .get("/log/log_lst")
        .then(function (response) {
          that.updateLogData = response.data;
        })
        .catch(function (error) {
          if (error.response) {
            that.$message.warning(error.response.data.data.msg);
          } else {
            that.$message.warning(error.message);
          }
        });
    },
    goToDocumentation: function (id) {
      this.$router.push({
        path: "/Documentation",
        query: { updateLogId: id },
      });
    },
  },
  filters: {
    createTimeFilter: function (input) {
      let createTimeArray = input.split(' ')
      let dateArray = createTimeArray[0].split('-')
      return dateArray.join('/')
    }
  }
};
</script>

<style scoped>
.update-log {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.update-log .update-log-inner {
  width: 1240px;
  height: auto;
  padding: 0px 20px 20px 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  overflow: auto;
}
.update-log .update-log-inner div:first-child {
  width: 100%;
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC Bold, PingFang SC Bold-Bold;
  font-weight: 700;
  text-align: center;
  color: #333333;
  line-height: 28px;
  margin-top: 30px;
}
.update-log .update-log-inner .firstChild {
  width: 100%;
  height: 50px;
  font-size: 14px;
  font-family: PingFang SC Medium, PingFang SC Medium-Medium;
  font-weight: 500;
  text-align: center;
  color: #999999;
  line-height: 50px;
}
.updateLogContent {
  width: 100%;
  height: 46px;
  font-size: 16px;
  font-family: PingFang SC Regular, PingFang SC Regular-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}
.update-log .update-log-inner .update-log-line {
  width: 100%;
  height: 1px;
  background: rgba(229, 233, 235, 1);
}
ul {
  margin: 0;
  padding: 0;
  width: 100%;
  list-style: none;
}
ul li {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
  cursor: pointer;
  margin-top: 15px;
}
ul li:hover {
  color: rgba(139, 182, 68, 0.5);
}
.update-log-title {
  width: 25%;
  float: left;
}
.update-log-time {
  width: 75%;
  float: right;
  text-align: left;
}
</style>
